import axios from 'external/axios'
import uploadFileTypes from 'components/Uploads/redux/types'
import { modifyFiles } from 'components/Uploads/redux/utils'
import {STATUS_UPLOAD} from 'components/Uploads/redux/constants'

const INITIAL_STATE = {
  fileProgress: {
    // format will be like below
    // 1: {
    //   id: 1,
    //   file,
    //   progress: 0,
    //   cancelSource: source,
    //   status: 0,
    // },
  },
}

const fileProgressReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case uploadFileTypes.RESET_UPLOADS:
      return {
        ...INITIAL_STATE,
      }

    case uploadFileTypes.SET_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          ...modifyFiles(state.fileProgress, action.payload),
        },
      }
      
    case uploadFileTypes.SET_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          ...modifyFiles(state.fileProgress, action.payload),
        },
      }

    case uploadFileTypes.SET_UPLOAD_PROGRESS:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload.id]: {
            ...state.fileProgress[action.payload.id],
            progress: action.payload.progress,
          },
        },
      }

    case uploadFileTypes.SUCCESS_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload]: {
            ...state.fileProgress[action.payload],
            status: STATUS_UPLOAD.success,
          },
        },
      }

    case uploadFileTypes.FAILURE_UPLOAD_FILE:
    return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload]: {
            ...state.fileProgress[action.payload],
            status: STATUS_UPLOAD.failed,
            progress: 0,
          },
        },
      }

    case uploadFileTypes.DELETE_UPLOAD_FILE:
      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload]: {
            ...state.fileProgress[action.payload],
            status: STATUS_UPLOAD.deleted,
            progress: 0,
          },
        },
      }

    case uploadFileTypes.RETRY_UPLOAD_FILE:
      const CancelToken = axios.CancelToken
      const cancelSource = CancelToken.source()

      return {
        ...state,
        fileProgress: {
          ...state.fileProgress,
          [action.payload]: {
            ...state.fileProgress[action.payload],
            status: STATUS_UPLOAD.uploading,
            progress: 0,
            cancelSource,
          }
        }
      }

    case uploadFileTypes.LOAD_UPLOADS:
      let files = {}
      action.payload.map((f, i)=> {
        let id = '' + (i+1)
        files[id] = {
          id: id,
          file: {
            name: f.name,
            size: 0
          },
          server: f.server,
          folder: f.folder,
          progress: 100,
          status: 1
        }
      })
      // console.log('payload',action.payload)
      return {
        ...state,
        fileProgress: files
      }

    default:
      return state
  }
}

export default fileProgressReducer
